import colors from '@styles/theme/colors';

function getSplashBackgroundColor() {
    return colors.productDark100;
}

export default getSplashBackgroundColor;
